import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import {store} from "./redux-store/store";
import {interceptor} from "./api/apiInterceptor";


import 'bootstrap/dist/css/bootstrap.min.css';
import "./css/main.css"
import 'antd/dist/antd.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

interceptor(store);
root.render(
    //Pravi problem oko useEffect, duplo ga renderuje iz nekog razloga, problem stvara kad se duplaju pozivi apija
    // <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
     // </React.StrictMode>
);

reportWebVitals();
